<template>
  <b-modal
    ref="skillCardResultModal"
    hide-footer
    :title="card.skillmap"
    centered
    scrollable
    lazy
    size="md"
    @hide="hideModal"
  >
    <div class="p-2">
      <div class="mb-2">
        <p class="step-text" v-if="card.step"><strong>Step: </strong>{{ card.step }}</p>
      </div>
      <div
        :style="{ marginBottom: card.results && card.results.length ? '32px' : '10px' }"
        v-b-popover.hover.top="
          card.status === SKILLCARD_STATUS.PENDING
            ? 'Your ai skill card will be published once it is approved by the admin'
            : null
        "
      >
        <div v-if="card.status" class="status mb-2" :style="{ color: getStatusColor(card.status) }">
          <span class="mr-1"><strong style="color: black;">Approval Status: </strong>{{ STATUSES[card.status] }}</span>
          <i class="material-icons icon-16pt mr-1 flex-shrink-0" v-if="card.status === SKILLCARD_STATUS.PENDING"
            >schedule</i
          >
          <i class="material-icons icon-16pt mr-1 flex-shrink-0" v-else-if="card.status === SKILLCARD_STATUS.APPROVED"
            >check_circle</i
          >
          <i class="material-icons icon-16pt mr-1 flex-shrink-0" v-else-if="card.status === SKILLCARD_STATUS.REJECTED"
            >cancel</i
          >
        </div>
      </div>

      <div class="anchors-section" v-if="card.results && card.results.length">
        <h3 class="anchors-title">ALL ANCHORS:</h3>

        <div class="anchor-list">
          <div v-for="result in card.results" :key="result.id">
            <div
              class="result-anchor mb-2 d-flex align-items-center"
              :style="{ color: result.is_correct ? 'black' : 'red' }"
            >
              <i class="material-icons icon-16pt mr-1  flex-shrink-0" style="color: green;" v-if="result.is_correct"
                >check_circle</i
              >
              <i class="material-icons icon-16pt mr-1  flex-shrink-0" v-else>cancel</i>

              <span style="flex: 1;">
                {{ result.anchor }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="pb-2 text-muted" style="justify-self: anchor-center;">
        <i>Evaluation Report not found.</i>
      </div>

      <div class="precision-section" v-if="card.precision !== null">
        <div class="precision-indicator" style="color: deepskyblue;">
          <i class="fas fa-solid fa-bullseye mr-1"></i>
          <span class="precision-text">Precision: {{ card.precision }}%</span>
        </div>
        <div v-if="getLoggedInUser.role_type === USER_ROLE_TYPES['SCHOOL'] && card.status === SKILLCARD_STATUS.PENDING">
          <b-btn
            :disabled="isUpdateStatus"
            variant="success"
            class="mr-2 btn-normal"
            @click.prevent="updateStatus(SKILLCARD_STATUS.APPROVED)"
          >
            Approve
          </b-btn>

          <b-btn
            :disabled="isUpdateStatus"
            variant="danger"
            class=" btn-normal"
            @click.prevent="updateStatus(SKILLCARD_STATUS.REJECTED)"
          >
            Reject
          </b-btn>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { USER_ROLE_TYPES, SKILLCARD_STATUS } from '@/common/constants';
import { mapGetters } from 'vuex';
export default {
  name: 'SkillCardResultModal',
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    card: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      windowWidth: window.innerWidth,
      USER_ROLE_TYPES,
      SKILLCARD_STATUS,
      isUpdateStatus: false,
      STATUSES: { pending: 'Pending', approved: 'Approved', rejected: 'Not Approved' },
    };
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        this.$refs.skillCardResultModal.show();
      } else {
        this.$refs.skillCardResultModal.hide();
      }
    },
  },
  computed: {
    ...mapGetters('auth', ['getLoggedInUser']),
    isMobileScreen() {
      return this.windowWidth <= 420;
    },
  },
  methods: {
    hideModal() {
      this.$emit('hide-modal');
    },
    async updateStatus(status) {
      this.isUpdateStatus = true;
      this.$emit('update-status', { id: this.card.id, status: status });
      this.isUpdateStatus = false;
    },
    getStatusColor(status) {
      if (status === 'approved') {
        return 'green';
      } else if (status === 'rejected') {
        return 'red';
      } else {
        return 'orange';
      }
    },
  },
};
</script>

<style scoped>
.close-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  color: #6b7280;
  transition: all 0.2s;
}

.close-button:hover {
  background-color: #f3f4f6;
  color: #374151;
}

.modal-content {
  padding: 0 24px 24px 24px;
}

.result-anchor {
  border: solid 1px #d1d5db;
  border-radius: 0.375rem;
  padding: 0.5rem 0.75rem;
  background-color: #f3f5f8;
}

.step-text {
  margin: 0;
  color: black;
}

.anchors-section {
  margin-bottom: 32px;
}

.anchors-title {
  margin: 0 0 20px 0;
  font-size: 14px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.anchor-list {
  display: flex;
  flex-direction: column;
}

.anchor-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.anchor-icon {
  flex-shrink: 0;
}

.anchor-text {
  font-size: 15px;
  line-height: 1.5;
}

.anchor-text.completed {
  color: #374151;
}

.anchor-text.incomplete {
  color: #ef4444;
}

.precision-section {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #e5e7eb;
  padding-top: 15px;
}

.precision-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
}

.precision-text {
  font-size: 14px;
  font-weight: 500;
}

/* Responsive design */
@media (max-width: 640px) {
  .modal-content {
    padding: 0 20px 20px 20px;
  }

  .step-text {
    font-size: 15px;
  }
}
</style>
